import { render, staticRenderFns } from "./LatestArticle.vue?vue&type=template&id=126b555d&"
import script from "./LatestArticle.vue?vue&type=script&lang=js&"
export * from "./LatestArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports